<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MaintainReport/Checker'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3">
                <div class="form-group ">
                  <label class="label">วันที่รับเข้าคลังดี(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateStart"
                      name="jobsDateStart"
                      ref="jobsDateStart"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">วันที่รับเข้าคลังดี(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="jobsDateEnd"
                      name="jobsDateEnd"
                      ref="jobsDateEnd"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label>BARCODE :</label>
                  <input v-model="qiOldBarcode" type="text" class="form-control" placeholder="BARCODE"/>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label>เลขที่ใบงาน :</label>
                  <input v-model="qiJobNumber" type="text" class="form-control" placeholder="เลขที่ใบงาน"/>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group ">
                  <label class="label">วันที่ซ่อมเสร็จ(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="finishedDateStart"
                      name="finishedDateStart"
                      ref="finishedDateStart"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">วันที่ซ่อมเสร็จ(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="finishedDateEnd"
                      name="finishedDateEnd"
                      ref="finishedDateEnd"
                      readonly
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ชื่อสินค้า:</label>
                  <treeselect id="qiProductCode" v-model="qiProductCode" :multiple="true" :options="qiProductCodeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ประเภทสินค้า:</label>
                  <treeselect id="qiProductType" v-model="qiProductType" :multiple="true" :options="qiProductTypeOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">ชื่อช่าง:</label>
                  <treeselect
                    v-model="qiUserId"
                    :multiple="true"
                    :load-options="LoadUsersIdOptions"
                    :async="true"
                    v-on:open="reLoadUsersIdOptions"
                    v-on:select="ClearAfterselect"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="true"
                    ref="qiUserId"
                  />
                </div>
              </div>
              <div class="col-xl-3">
                <div class="form-group">
                  <label class="label">สถานะการรับเข้าคลังดี:</label>
                  <treeselect id="checkerStatus" v-model="checkerStatus" :multiple="true" :options="qiCheckerStatusOptions"
                    :clear-on-select="true" placeholder="กรุณาเลือก" />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right" v-if="this.$root.canShow(['OFFICER_QIMAINTAIN','OFFICER_PLANT_QIMAINTAIN','CHECKER_QIMAINTAIN','LEAD_QIMAINTAIN'])">
                <button
                  class="btn btn-outline-primary"
                  @click="exportExcel"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped table-bordered table-hover table-checkable"
                id="reportTable" style="width:100%"
              >
                <thead>
                    <tr>
                        <td class="text-center font-weight-bold">วันที่ส่งมอบหลังซ่อม<br>(รับเข้าคลังดี ว/ด/ป)</td>
                        <td class="text-center font-weight-bold">Month</td>
                        <td class="text-center font-weight-bold">Year</td>
                        <td class="text-center font-weight-bold">เลขที่ใบงาน</td>
                        <td class="text-center font-weight-bold">ประเภทสินค้า</td>
                        <td class="text-center font-weight-bold">รหัสสินค้า</td>
                        <td class="text-center font-weight-bold">ชื่อสินค้า</td>
                        <td class="text-center font-weight-bold">จำนวน</td>
                        <td class="text-center font-weight-bold">BARCODE</td>
                        <td class="text-center font-weight-bold">ชื่อช่าง</td>
                        <td class="text-center font-weight-bold">รับประกันการซ่อม ว/ด/ป</td>
                        <td class="text-center font-weight-bold">วันที่ซ่อมเสร็จ ว/ด/ป</td>
                    </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import select2 from "../../Shared/Select2";
import axios from "axios";
import Collapsible from "../../Shared/Collapsible";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
require("sweetalert2");

export default {
  components: {
    select2,
    Collapsible,
    Treeselect,
  },
  data: function() {
    var self = this;
    return {
      jobsDateStart: null,
      jobsDateEnd: null,
      finishedDateStart: null,
      finishedDateEnd: null,
      qiProductCode: null,
      qiProductType: null,
      checkerStatus: null,
      qiProductCodeOptions: [],
      qiProductTypeOptions: [],
      qiProductBrandOptions: [],
      qiCheckerStatusOptions: [],
      qiOldBarcode: null,
      qiJobNumber: null,
      qiUserId: [],
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      this.jobsDateStart = null;
      this.jobsDateEnd = null;
      this.finishedDateStart = null;
      this.finishedDateEnd = null;
      this.qiProductCode = null;
      this.qiProductType = null;
      this.checkerStatus = null;
      this.qiOldBarcode = null;
      this.qiJobNumber = null;
      this.qiUserId = [];

      $(`#jobsDateStart`).val("").trigger("change");
      $(`#jobsDateEnd`).val("").trigger("change");
      $(`#finishedDateStart`).val("").trigger("change");
      $(`#finishedDateEnd`).val("").trigger("change");
      $(`#qiProductCode`).val("").trigger("change");
      $(`#qiProductType`).val("").trigger("change");
      $(`#checkerStatus`).val("").trigger("change");
      $(`#qiUserId`).val("").trigger("change");

      // this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#reportTable").DataTable();
      table.search();
      table.draw();
    },
    exportExcel: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/QIJobs/ExportChecker",
        responseType: "arraybuffer",
        data: {
          StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
          EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
          QIProductCode: self.qiProductCode,
          QIProductType: self.qiProductType,
          QICheckerStatus: self.checkerStatus,
          Barcode: self.qiOldBarcode,
          QIJobNumber: self.qiJobNumber,
          QiUserId: self.qiUserId,
          FinishedStartDate: self.finishedDateStart != null ? self.finishedDateStart.format("DD/MM/YYYY") : null,
          FinishedEndDate: self.finishedDateEnd != null ? self.finishedDateEnd.format("DD/MM/YYYY") : null,
        },
      })
      .then(function(response) {
        if (response.status == "200") {
          let filename = "";
          let contentType = response.headers["content-type"];
          let disposition = response.headers["content-disposition"];
          //===Get Filename===
          if (disposition && disposition.indexOf("attachment") !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, "");
            }
          }
          //Save file
          let blob = new Blob([response.data], { type: contentType });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = decodeURIComponent(filename);
          link.click();
        } else if (response.status == "204") {
          Swal.fire(
            "ไม่พบข้อมูล",
            "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา",
            "warning"
          );
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
      })
      .then(function() {
        KTApp.unblockPage();
      });
    },
    LoadreProductCodeOptions: function (e) {
      var self = this;
      var qiTypesArray = ['QiSpare', 'QiMachine', 'QiEquipment'];
      axios
        .post("/Api/QIJobs/ProductOption", {
          page: 0,
          limit: 1000,
          optionWithCode: true,
          qiTypes: qiTypesArray
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductCodeOptions = [];
            data.forEach((element) => {
              self.qiProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreQIProductTypeOptions: function (e) {
      var self = this;
      axios
        .get("/Api/QIJobs/SubProductType")
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductTypeOptions = [];
            data.forEach((element) => {
              self.qiProductTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreQIProductBrandOptions: function (e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.qiProductBrandOptions = [];
            data.forEach((element) => {
              self.qiProductBrandOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function (error) { });
    },
    LoadreEvalStatusOptionsOptions: function (e) {
      var self = this;
      self.qiCheckerStatusOptions = [];
      var data = [
        {
          id: "StatusChecked",
          text: "รับเข้าคลังดีแล้ว",
        },
        {
          id: "StatusWait",
          text: "ยังไม่ได้รับเข้าคลังดี",
        },
      ];
      data.forEach((element) => {
        self.qiCheckerStatusOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    reLoadUsersIdOptions: function(){
      this.$refs.qiUserId.trigger.searchQuery = null;
    },
    LoadUsersIdOptions({ action, searchQuery, callback }){
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/QIJobs/User/Options",{ 
            page: 1,
            search: searchQuery,
            all: true,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              var result = [];
              data.forEach((element) => {
                result.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, result);
          })
          .catch(function(error) {});
      }
    },
  },
  async mounted() {
    let self = this;
    self.LoadreProductCodeOptions();
    self.LoadreQIProductTypeOptions();
    self.LoadreQIProductBrandOptions();
    self.LoadreEvalStatusOptionsOptions();
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.jobsDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateStart).on("changeDate", function(e) {
      self.jobsDateStart = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.jobsDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.jobsDateEnd).on("changeDate", function(e) {
      self.jobsDateEnd = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.finishedDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.finishedDateStart).on("changeDate", function(e) {
      self.finishedDateStart = e.dates.length != 0 ? moment(e.date) : null;
    });

    $(self.$refs.finishedDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.finishedDateEnd).on("changeDate", function(e) {
      self.finishedDateEnd = e.dates.length != 0 ? moment(e.date) : null;
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#reportTable");
    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/QIJobs/SearchChecker",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              StartDate: self.jobsDateStart != null ? self.jobsDateStart.format("DD/MM/YYYY") : null,
              EndDate: self.jobsDateEnd != null ? self.jobsDateEnd.format("DD/MM/YYYY") : null,
              QIProductCode: self.qiProductCode,
              QIProductType: self.qiProductType,
              QICheckerStatus: self.checkerStatus,
              Barcode: self.qiOldBarcode,
              QIJobNumber: self.qiJobNumber,
              QiUserId: self.qiUserId,
              FinishedStartDate: self.finishedDateStart != null ? self.finishedDateStart.format("DD/MM/YYYY") : null,
              FinishedEndDate: self.finishedDateEnd != null ? self.finishedDateEnd.format("DD/MM/YYYY") : null,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [30, 50, 100],
        pageLength: 30,
        language: {lengthMenu: "Display _MENU_",},
        // order: [[10, "asc"]],
        ordering: false,
        columns: [
          {
            data: "checkerDate",
            className: "text-center",
            render: function (data) {
              return data
                ? moment(data).format("DD/MM/YYYY")
                : "ยังไม่ได้รับเข้าคลังดี";
            }
          },
          {
            data: "checkerDate",
            className: "text-center",
            render: function (data) {
              return data
                ? moment(data).format("MM")
                : "-";
            }
          },
          {
            data: "checkerDate",
            className: "text-center",
            render: function (data) {
              return data
                ? moment(data).format("YYYY")
                : "-";
            }
          },
          {
            data: "qiJobNumber",
            className: "text-center",
            render: function (data) {
              return data && data.trim()
                ? data
                : "-";
            }
          },
          {
            data: "subProductTypeName",
            className: "text-center",
            render: function (data) {
              return data && data.trim()
                ? data
                : "-";
            }
          },
          {
            data: "materialCode",
            className: "text-center",
            render: function (data) {
                return data && data.trim()
                    ? data
                    : "-";
            }
          },
          {
            data: "materialName",
            className: "text-center",
            render: function (data) {
              return data && data.trim()
                ? data
                : "-";
            }
          },

          {
            data: "amount",
            className: "text-center",
            render: function (data) {
            return data !== null && data !== undefined
                ? Number(data).toLocaleString('en-US')
                : 0;
            }
          },
          {
            data: "barcodeNoOld",
            className: "text-center",
            render: function (data) {
              return data && data.trim()
                ? data
                : "ไม่มี BARCODE";
            }
          },
          {
            data: null,
            className: "text-center",
            render: function (data, type, row) {
              return row.firstName && row.lastName
                ? `${row.firstName} ${row.lastName}`
                : row.fullName
                ? row.fullName
                : "-";
            }
          },
          {
            data: null,
            className: "text-center",
            render: function (data, type, row) {
              var guaranteeDate =
                row.qiSubType === 1
                  ? row.machGuaranteeDate
                  : row.qiSubType === 2
                  ? row.eqptGuaranteeDate
                  : null;
              return guaranteeDate
                ? moment(guaranteeDate).format("DD/MM/YYYY")
                : "-";
            }
          },
          {
            data: "finishedDate",
            className: "text-center",
            render: function (data) {
              return data
                ? moment(data).format("DD/MM/YYYY")
                : "-";
            }
          }
        ]
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new Action({ data: { data }, parent: self }).$mount(el);
          }
        });
      });

  },
};
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// App/Components/QIJob/ReportChecker.vue